import config from "../config.json";
import axios from "axios";
import { AXIOS } from "../utils/global_variables";

const TenantId = config.TenantId;

export async function termsCondtion() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/TermsCondition.txt`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp;
    } catch (error) {
        console.error("Error in terms and condition API ->", error.message);
        throw error;
    }
}


export async function sipTermsCondition() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/eqsiptermsandconditions.txt`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp;
    } catch (error) {
        console.error("Error in terms and condition API ->", error.message);
        throw error;
    }
}

export async function aboutUs() {
    try {

        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/AboutUs.txt`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp;
    } catch (error) {
        console.error("Error in about us API ->", error.message);
        throw error;
    }
}

export async function disclaimer() {
    try {

        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/Disclaimer.txt`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp;
    } catch (error) {
        console.error("Error in Disclaimer API ->", error.message);
        throw error;
    }
}

export async function exchangeTimings() {
    try {

        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/BzExchangeTime.json?t=${new Date().getTime()}`,
            { timeout: AXIOS.TIMEOUT }
        );

        return objResp;
    } catch (error) {
        console.error("Error in exchangeTime API ->", error.message);
        throw error;
    }
}

export async function brokerInformation() {
    try {

        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/brokerinformation.json?t=${new Date().getTime()}`,
            { timeout: AXIOS.TIMEOUT }
        );

        return objResp;
    } catch (error) {
        console.error("Error in brokerinformation API ->", error.message);
        throw error;
    }
}

export async function statesCities() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/statesCities.json?t=${new Date().getTime()}`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp
            ;
    } catch (error) {
        console.error(`Error in statesCities API ->${error.message}`);
    }
}

export async function termConditionIpo() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/IPOTermsAndConditions.txt`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp
            ;
    } catch (error) {
        console.error(`Error in statesCities API ->${error.message}`);
    }
}


export async function getInvestmentDetails() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/Investments.json?t=${new Date().getTime()}`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp;
    } catch (error) {
        console.error(`Error in Investment API -> ${error}`);
    }
}

//Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - Start
export async function dynamicMenus() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/BzDynamicMenu.json?t=${new Date().getTime()}`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp;
    } catch (error) {
        console.error(`Error in dynamicMenus API ->${error.message}`);
    }
}
//Maaz A : 30-08-2023 : BT-116689 - Breeze - Create Dynamic Menu - End

export async function ssoLink() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/SSOLinks.json?t=${new Date().getTime()}`,
            { timeout: AXIOS.TIMEOUT }
        );
        return objResp;
    } catch (error) {
        console.error(`Error in dynamicMenus API ->${error.message}`);
    }
}





//Ameersha N : 18-10-2023 : Breeze - Manage Columns Menu - Start

export async function getViewWiseColumnsList() {
    try {
        const objResp = await axios.get(`${config.Wave.Cloudfront_S3_URL}${TenantId}/v1/BzViewWiseColumnList.json?t=${new Date().getTime()}`,
            { timeout: AXIOS.TIMEOUT, guestAllowed:true }
        );
        return objResp;
    } catch (error) {
        console.error(`Error in dynamicMenus API ->${error.message}`);
    }
}

//Ameersha N : 18-10-2023 : Breeze - Manage Columns Menu - Start
